import {
  CheckboxCardInputType,
  InputSize,
  Layout,
  RedoCheckboxCard,
} from "@redotech/arbiter/checkbox/redo-checkbox-card";
import { memo, ReactNode } from "react";

export interface PortalSelectionCardProps {
  title: ReactNode;
  children?: ReactNode;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  inputType?: CheckboxCardInputType;
  inputSize?: InputSize;
  layout?: Layout;
  childrenFullWidth?: boolean;
  icon?: ReactNode;
  isFramedIcon?: boolean;
  dataTestId?: string;
  uiSelector?: string;
}

export const PortalSelectionCard = memo(function PortalSelectionCard({
  title,
  children,
  selected = false,
  disabled,
  onClick,
  inputType,
  inputSize = "sm",
  layout = Layout.SHORT,
  childrenFullWidth,
  icon,
  isFramedIcon,
  dataTestId,
  uiSelector,
}: PortalSelectionCardProps) {
  return (
    <RedoCheckboxCard
      checked={selected}
      childrenFullWidth={childrenFullWidth}
      dataTestId={dataTestId}
      disabled={disabled}
      icon={icon}
      inputSize={inputSize}
      inputType={inputType}
      isFramedIcon={isFramedIcon}
      layout={layout}
      onClick={disabled ? undefined : onClick}
      title={title}
      uiSelector={uiSelector}
    >
      {children}
    </RedoCheckboxCard>
  );
});
